import CustomersEntityTable from './CustomersEntityTable';

export default CustomersEntityTable;
